<template>
  <div class="navbarRight">
    <dv-border-box-11 title="业务信息">
      <dv-decoration-3 />

      <dv-decoration-7 class="totalQty">库存总量</dv-decoration-7>
      <div id="echartContainer"></div>

      <dv-decoration-2 class="pullPlan" />

      <dv-decoration-7 class="pullPlan7">配送清单</dv-decoration-7>
      <dv-scroll-board :config="configPullData" />
    </dv-border-box-11>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: "AppNavbar",
  data() {
    return {
      configtop10: {
        data: [
          {
            name: "南阳",
            value: 167,
          },
          {
            name: "周口",
            value: 123,
          },
          {
            name: "漯河",
            value: 98,
          },
          {
            name: "郑州",
            value: 75,
          },
          {
            name: "西峡",
            value: 66,
          },
          {
            name: "南阳1",
            value: 167,
          },
          {
            name: "周口1",
            value: 123,
          },
          {
            name: "漯河1",
            value: 98,
          },
          {
            name: "郑州1",
            value: 75,
          },
          {
            name: "西峡1",
            value: 66,
          },
        ],
        colors: [
          "#e062ae",
          "#fb7293",
          "#e690d1",
          "#32c5e9",
          "#96bfff",
          "#fb7293",
          "#e690d1",
          "#32c5e9",
          "#96bfff",
          "#96bfff",
        ],
        unit: "箱",
        showValue: true,
      },
      configPullData: {
        header: ["列1", "列2", "列3"],
        data: [
          ['<span style="color:#37a2da;">行1列1</span>', "行1列2", "行1列3"],
          ["行2列1", '<span style="color:#32c5e9;">行2列2</span>', "行2列3"],
          ["行3列1", "行3列2", '<span style="color:#67e0e3;">行3列3</span>'],
          ["行4列1", '<span style="color:#9fe6b8;">行4列2</span>', "行4列3"],
          ['<span style="color:#ffdb5c;">行5列1</span>', "行5列2", "行5列3"],
          ["行6列1", '<span style="color:#ff9f7f;">行6列2</span>', "行6列3"],
          ["行7列1", "行7列2", '<span style="color:#fb7293;">行7列3</span>'],
          ["行8列1", '<span style="color:#e062ae;">行8列2</span>', "行8列3"],
          ['<span style="color:#e690d1;">行9列1</span>', "行9列2", "行9列3"],
          ["行10列1", '<span style="color:#e7bcf3;">行10列2</span>', "行10列3"],
        ],
        index: true,
        columnWidth: [50],
        align: ["center"],
      },
    };
  },
  mounted() {
    // 调用当前图表
    this.dataChart();
  },
  methods: {
    dataChart() {
      // 基于准备好的dom，初始化echarts实例

      var chartDom = document.getElementById("echartContainer");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: "",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["邮件", "联盟", "视频", "访问", "引擎"],
          textStyle: {
            fontSize: 18, //字体大小
            color: "#ffffff", //字体颜色
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ffffff",
            },
          },
        },
        yAxis: {
          type: "value",
          //設置字体颜色
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ffffff",
            },
          },
        },
        series: [
          {
            name: "邮件",
            type: "line",
            stack: "总量",
            data: [120, 132, 101, 134, 90, 230, 210],
          },
          {
            name: "联盟",
            type: "line",
            stack: "总量",
            data: [220, 182, 191, 234, 290, 330, 310],
          },
          {
            name: "视频",
            type: "line",
            stack: "总量",
            data: [150, 232, 201, 154, 190, 330, 410],
          },
          {
            name: "访问",
            type: "line",
            stack: "总量",
            data: [320, 332, 301, 334, 390, 330, 320],
          },
          {
            name: "引擎",
            type: "line",
            stack: "总量",
            data: [820, 932, 901, 934, 1290, 1330, 1320],
          },
        ],
      };

      myChart.setOption(option);
    },
  },
};
</script>

<style    scoped>
.dv-decoration-3 {
  width: 100%;
  height: 2%;
  top: 7%;
  position: absolute;
}
.totalQty {
  left: 6%;
  top: 10%;
}
#echartContainer {
 
  width: 100%;
  height: 40%;
  top: 14%;
}
.dv-decoration-9 {
  width: 30%;
  height: 10%;
  top: 14%;
  position: absolute;
  color: white;
}

.safaQty9 {
  left: 55%;
}
.totalQty9 {
  left: 10%;
}
.dv-decoration-2 {
  position: absolute;
  top: 28%;
  left: 2%;
  width: 90%;
  height: 1%;
}
.dv-decoration-7 {
  position: absolute;
  width: 35%;
  height: 2%;
  color: rgb(3, 232, 248);

  font-size: 200;
}

.pullPlan {
  top: 59%;
}
.pullPlan7 {
  top: 63%;
  left: 10%;
  width: 70%;
}
.dv-scroll-board {
  top: 28%;
  width: 90%;
  height: 30%;
  left: 4%;
}
</style>
 